// extracted by mini-css-extract-plugin
module.exports = {"bottomDetailsContainer":"GameDetailsContainer_bottomDetailsContainer__xqZ9r","bold":"GameDetailsContainer_bold__1U_Qz"};